var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-user",
    transform: "translate(-181 -31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_806",
    "data-name": "Groupe 806",
    transform: "translate(181 31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    fill: "#2341d0",
    stroke: "#11ff64",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "user",
    d: "M0,26.655V21.581s7.693-4.721,13.359-4.727,13.512,4.727,13.512,4.727v5.074ZM6.061,7.375a7.378,7.378,0,1,1,7.375,7.375A7.376,7.376,0,0,1,6.061,7.375Z",
    transform: "translate(193.562 43.675)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.67de9dd0c396e094fb25ed7f9e939ef8.svg";
export { ForwardRef as ReactComponent };